import { Component } from '@angular/core';
import { TableColDef, TableComponent } from '@group24ag/flowkit';

@Component({
  selector: 'app-ui-tables',
  imports: [TableComponent],
  template: `
    <div>
      <h1 class="heading-title">Tables</h1>
      <div style="height: 300px">
        <!-- The AG Grid component, with Dimensions, CSS Theme, Row Data, and Column Definition -->
        <flk-table
          [rowSelection]="{ mode: 'multiRow' }"
          [rowData]="rowData"
          [colDefs]="colDefs">
        </flk-table>
      </div>
    </div>
  `,
})
export class UITablesComponent {
  // Row Data: The data to be displayed.
  rowData = [
    {
      make: 'Tesla',
      model: 'Model Y',
      price: 64950,
      electric: true,
      foo: true,
    },
    { make: 'Ford', model: 'F-Series', price: 33850, electric: false },
    { make: 'Toyota', model: 'Corolla', price: 29600, electric: false },
  ];

  // Column Definitions: Defines the columns to be displayed.
  colDefs: TableColDef[] = [
    { field: 'make' },
    { field: 'model' },
    { field: 'price' },
    { field: 'electric' },
    { field: 'foo' },
  ];
}
